import { FindStatus } from '@src/types/oneTouchSwitching';
import { OTSFormValues } from '@src/types/yourDetails';

const OTS_INCOMPLETE_ERROR = 'Please complete your switch';

interface OTSErrors {
  otsFindStatus?: string;
}

const isSwitchComplete = (values: OTSFormValues) =>
  !values.otsHasExistingLine ||
  values.otsProviderNotListed ||
  [
    FindStatus.FINDING,
    FindStatus.FOUND,
    FindStatus.FAIL,
    FindStatus.SUCCESS,
  ].includes(values.otsFindStatus);

const validate = (values: OTSFormValues, canSwitch: boolean): OTSErrors => {
  if (canSwitch && !isSwitchComplete(values)) {
    return { otsFindStatus: OTS_INCOMPLETE_ERROR };
  }

  return {};
};

export { validate, isSwitchComplete, OTS_INCOMPLETE_ERROR };
